import { useMutation } from '@tanstack/react-query';
import { api } from 'src/services/api';
import { Appointment } from 'src/models';
import { useAppointmentListClient } from './useGetAppointmentList';
import { useAppointmentDetailsClient } from './useGetAppointmentDetails';

export type UseDeleteAppointmentPayload = {
  appt_uuid: Appointment['appt_uuid'];
};

export const useDeleteAppointment = () => {
  const { deleteAppointment } = useAppointmentListClient();
  const { deleteAppointment: deleteAppointmentDetails } =
    useAppointmentDetailsClient();
  return useMutation({
    mutationKey: ['deleteAppointment'],
    mutationFn: ({ appt_uuid }: UseDeleteAppointmentPayload) => {
      return api
        .delete(`/delete_appointment/${appt_uuid}`)
        .then((res) => res.data);
    },
    onSuccess: (_, { appt_uuid }) => {
      deleteAppointment({ uuid: appt_uuid });
      deleteAppointmentDetails({ appt_uuid });
    },
  });
};
